import { render, staticRenderFns } from "./IssuedPersonsForm.vue?vue&type=template&id=c6023ce0&"
import script from "./IssuedPersonsForm.vue?vue&type=script&lang=js&"
export * from "./IssuedPersonsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports